import React from 'react';
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import DealerByPostcodeModule from '../components/DealerByPostcodeModule';
import ModelModule from '../components/ModelModule';
import Spinner from '../audi-ui-components/Spinner';
import Button from "../audi-ui-components/Button";
import API from '../functions/api';
import { formatMobile } from '../functions/textFormatting';
import { gtmPageview } from '../functions/gtm';
import { prefCentreService } from '../functions/apiRequestHelper';
import _find from "lodash/find";
import {
    PATH_DEALER_OFFER,
    PATH_F1_ENQUIRY,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_SELECT,
    FIELD_CHECKBOX,
    LABEL_OPTIN,
    UI_AUDI,
    DEFAULT_THEME,
} from '../constants';

class DealerOffer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isFetchingUser: true,
            user: {},
            variants: [],
            submitted: false,
            submittedData: {},
            cta: null,
        }
    }

    componentDidMount() {
        const { match, history, location } = this.props;
        if (match.path === `${PATH_DEALER_OFFER}/:offerName${PATH_THANKS}`) {
            history.push(`${PATH_DEALER_OFFER}/${match.params.offerName}${location.search}`);
        }
        if (match.path === `${PATH_F1_ENQUIRY}/:offerName${PATH_THANKS}`) {
            history.push(`${PATH_F1_ENQUIRY}/${match.params.offerName}${location.search}`);
        }
        const query = queryString.parse(location.search);
        if (query.v) {
            let idArr = query.v.split(",").map(id => parseInt(id));
            API.post(`${process.env.RAZZLE_GQLAPI}`, {
                query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: VariantDtoSortInput!, $filter: VariantDtoFilterInput) {
                    variantList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
                        items {
                            value: variantId
                            label: name
                            heroImage
                            configuratorUrl
                        }
                        totalCount
                    }
                }`,
                variables: {
                    skip: 0,
                    take: 50,
                    sort: { name: "ASC" },
                    filter: { status: { eq: true }, variantId: { in: idArr } }
                }
            }).then((result) => {
                var opts = [];
                if (result.data?.data?.variantList?.items) {
                    opts = result.data.data.variantList.items;
                }
                this.setState({ variants: opts, loading: false });
            }).catch((error) => {
                console.error(error);
                this.setState({ loading: false });
            });
        } else {
            // no variants in query string
            this.setState({ loading: false });
        }
        if (query.sfid) {
            prefCentreService.get(query.sfid).then((result) => {
                this.setState({user: result, isFetchingUser: false});
            }).catch((error) => {
                // console.error('user error', error);
                this.setState({isFetchingUser: false});
            });
        } else {
            this.setState({isFetchingUser: false});
        }
        gtmPageview(PATH_DEALER_OFFER);
    }

    onSubmit = (values) => {
        const { match, history, location } = this.props;
        let mUrl = "";
        let cta = null;
        if (this.state.variants?.length > 0) {
            // get model URL from configurator URL
            let selectedVariant = values.variantId ? _find(this.state.variants, {value: parseInt(values.variantId)}) : null;
            let cUrl = selectedVariant?.configuratorUrl;
            let cIdx = cUrl ? cUrl.indexOf("configurator") : null;
            mUrl = cUrl ? cIdx > 0 ? cUrl.substring(0,cIdx) : cUrl : "";
            if (selectedVariant?.label?.toLowerCase() === "rs q8 performance" && match.params.offerName.toLowerCase() === "f1-event") {
                cta = {url: "https://audifoundation.com.au/prizedraw", text: "Audi Foundation prize draw"};
            }
        }
        this.setState({ submitted: true, submittedData: values, modelUrl: mUrl, cta: cta });
        let newPath = `${PATH_DEALER_OFFER}/${match.params?.offerName}${PATH_THANKS}`;
        if (match.path.indexOf(PATH_F1_ENQUIRY) > -1) {
            newPath = `${PATH_F1_ENQUIRY}/${match.params?.offerName}${PATH_THANKS}`;
        }
        history.push(newPath + location.search);
        gtmPageview(newPath);
        setTimeout(()=>{window.scrollTo(0,0)}, 500);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const { loading, isFetchingUser, submitted, variants, user } = this.state;
        const { match } = this.props;
        var prefillMobile = "";
        if (user?.mobile && user.mobile.indexOf('04') === 0) {
            prefillMobile = user.mobile.replace(/\s/g, '');
        }

        var fields = [
            [
                {
                    field: FIELD_TEXT,
                    name: "firstName",
                    label: "First name *",
                    value: user.firstName || "",
                },
                {
                    field: FIELD_TEXT,
                    name: "lastName",
                    label: "Last name *",
                    value: user.lastName || "",
                },
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email *",
                value: user.email || "",
            },
            {
                field: FIELD_TEXT,
                name: "mobilePhone",
                label: "Mobile phone *",
                formatValue: formatMobile,
                value: prefillMobile,
            }
        ];
        var validationSchema = {};
        if (variants && variants.length > 0) {
            fields.push({
                field: FIELD_SELECT,
                name: "variantId",
                label: "Model of interest *",
                options: variants,
                value: variants.length === 1 ? variants[0].value : "",
            });
            validationSchema.variantId = { presence: { message: "Please make a selection", allowEmpty: false } };
        } else {
            fields.push({
                module: ModelModule,
                modelListType: "test-drive-form"
            });
        }
        fields.push({
            module: DealerByPostcodeModule
        });
        fields.push({
            field: FIELD_CHECKBOX,
            name: "optIn",
            label: <>{LABEL_OPTIN}*</>
        });
        validationSchema.optIn = { truthy: { message: "This field is required" } };

        return (
            <Layout ui={query.ui || UI_AUDI} embedded={query.embedded} wide={query.wide} theme={theme}>
                <Helmet>
                    <title>Dealer Offer | Audi Australia</title>
                </Helmet>

                {variants?.length === 1 && variants[0].heroImage && query.img && <div className="audi-forms__hero-v2" style={{background: "#000"}}>
                    <img src={variants[0].heroImage} alt="" />
                </div>}

                <main className="audi-forms__page">

                    {(loading || isFetchingUser) && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                    {submitted && <div className="pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you.</h1>
                        <p className="mb-3">Your request has been submitted.</p>
                        {this.state.modelUrl && <p className="mb-5"><a href={this.state.modelUrl} className="aui-textlink">View model page</a></p>}
                        {!this.state.cta && <ReturnToButton query={query} theme={theme} />}
                        {this.state.cta && <Button variant="primary" href={this.state.cta.url}>{this.state.cta.text}</Button>}
                    </div>}

                    {!submitted && !loading && !isFetchingUser && <div className="pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Enquire now</h1>
                        <p className="mb-3">
                            Connect directly with your preferred Audi dealership to take advantage of this exceptional offer.
                        </p>
                        <AudiForm
                            formName="dealerOfferEnquiry"
                            fields={fields}
                            schema={validationSchema}
                            preSubmit={(payload) => {
                                if (payload.dealer) { payload.dealer = ""; }
                                return payload;
                            }}
                            hiddenFields={{ offerName: match.params.offerName, dealerContact: true }}
                            onSubmitSuccess={this.onSubmit}
                            submitIsStretched={false}
                            theme={theme}
                        />
                        <Disclaimer />
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default DealerOffer;
